export const hnSecurityReportBtnConfig = {
  text: 'Review security report',
  baseUrl: 'https://app.hypernative.xyz/guardian/alert',
} as const
